(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savi_mid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // ---------- CTA click tracking ----------
    window.dataLayer = window.dataLayer || [];

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.hero-btn-11, .hero-btn-22');
      if (!btn) return;

      var text = btn.innerText.trim();
      if (!text) return;

      window.dataLayer.push({
        event: 'Hp_banner_cta_click',
        cta_name: text,
        cta_url: btn.href,
        section: 'home_page_banner'
      });
    });

    // ---------- Slider (desktop only, starts after page load) ----------
    function initSlider() {
      if (window.innerWidth <= 768) return;

      var wrapper = document.querySelector('.hero-wrapper');
      if (!wrapper) return;

      var slides = wrapper.querySelectorAll('.hero-slide');
      if (slides.length < 2) return;

      // Clone first slide to the end for a seamless loop
      var clone = slides[0].cloneNode(true);
      clone.classList.remove('active');
      clone.setAttribute('aria-hidden', 'true');
      var cloneImg = clone.querySelector('img');
      if (cloneImg) {
        cloneImg.removeAttribute('fetchpriority');
        cloneImg.setAttribute('loading', 'lazy');
      }
      wrapper.appendChild(clone);

      var total = slides.length + 1;
      var current = 0;

      setInterval(function () {
        current++;
        wrapper.style.transition = 'transform 0.8s ease-in-out';
        wrapper.style.transform = 'translateX(-' + (current * 100) + '%)';

        if (current === total - 1) {
          setTimeout(function () {
            wrapper.style.transition = 'none';
            current = 0;
            wrapper.style.transform = 'translateX(0)';
          }, 800);
        }
      }, 4000);
    }

    if (document.readyState === 'complete') {
      initSlider();
    } else {
      window.addEventListener('load', initSlider);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
